exports.Countries = [
  {
    name: 'Afghanistan',
    code: 'AF',
    arabicName: 'أفغانستان',
    phoneCode: '+93'
  },
  {
    name: 'Åland Islands',
    code: 'AX',
    arabicName: 'جزر آلاند',
    phoneCode: '+358'
  },
  {
    name: 'Albania',
    code: 'AL',
    arabicName: 'ألبانيا',
    phoneCode: '+355'
  },
  {
    name: 'Algeria',
    code: 'DZ',
    arabicName: 'الجزائر',
    phoneCode: '+213'
  },
  {
    name: 'American Samoa',
    code: 'AS',
    arabicName: 'ساموا الأمريكية',
    phoneCode: '+1-684'
  },
  {
    name: 'Andorra',
    code: 'AD',
    arabicName: 'أندورا',
    phoneCode: '+376'
  },
  {
    name: 'Angola',
    code: 'AO',
    arabicName: 'أنغولا',
    phoneCode: '+244'
  },
  {
    name: 'Anguilla',
    code: 'AI',
    arabicName: 'أنغيلا',
    phoneCode: '+1-264'
  },
  {
    name: 'Antarctica',
    code: 'AQ',
    arabicName: 'أنتاركتيكا',
    phoneCode: null
  },
  {
    name: 'Antigua and Barbuda',
    code: 'AG',
    arabicName: 'أنتيغوا وبربودا',
    phoneCode: '+1-268'
  },
  {
    name: 'Argentina',
    code: 'AR',
    arabicName: 'الأرجنتين',
    phoneCode: '+54'
  },
  {
    name: 'Armenia',
    code: 'AM',
    arabicName: 'أرمينيا',
    phoneCode: '+374'
  },
  {
    name: 'Aruba',
    code: 'AW',
    arabicName: 'أروبا',
    phoneCode: '+297'
  },
  {
    name: 'Australia',
    code: 'AU',
    arabicName: 'أستراليا',
    phoneCode: '+61'
  },
  {
    name: 'Austria',
    code: 'AT',
    arabicName: 'النمسا',
    phoneCode: '+43'
  },
  {
    name: 'Azerbaijan',
    code: 'AZ',
    arabicName: 'أذربيجان',
    phoneCode: '+994'
  },
  {
    name: 'Bahamas',
    code: 'BS',
    arabicName: 'جزر البهاما',
    phoneCode: '+1-242'
  },
  {
    name: 'Bahrain',
    code: 'BH',
    arabicName: 'البحرين',
    phoneCode: '+973'
  },
  {
    name: 'Bangladesh',
    code: 'BD',
    arabicName: 'بنغلاديش',
    phoneCode: '+880'
  },
  {
    name: 'Barbados',
    code: 'BB',
    arabicName: 'بربادوس',
    phoneCode: '+1-246'
  },
  {
    name: 'Belarus',
    code: 'BY',
    arabicName: 'بيلاروسيا',
    phoneCode: '+375'
  },
  {
    name: 'Belgium',
    code: 'BE',
    arabicName: 'بلجيكا',
    phoneCode: '+32'
  },
  {
    name: 'Belize',
    code: 'BZ',
    arabicName: 'بليز',
    phoneCode: '+501'
  },
  {
    name: 'Benin',
    code: 'BJ',
    arabicName: 'بنين',
    phoneCode: '+229'
  },
  {
    name: 'Bermuda',
    code: 'BM',
    arabicName: 'برمودا',
    phoneCode: '+1-441'
  },
  {
    name: 'Bhutan',
    code: 'BT',
    arabicName: 'بوتان',
    phoneCode: '+975'
  },
  {
    name: 'Bolivia',
    code: 'BO',
    arabicName: 'بوليفيا',
    phoneCode: '+591'
  },
  {
    name: 'Bosnia and Herzegovina',
    code: 'BA',
    arabicName: 'البوسنة والهرسك',
    phoneCode: '+387'
  },
  {
    name: 'Botswana',
    code: 'BW',
    arabicName: 'بوتسوانا',
    phoneCode: '+267'
  },
  {
    name: 'Bouvet Island',
    code: 'BV',
    arabicName: 'جزيرة بوفيت',
    phoneCode: null
  },
  {
    name: 'Brazil',
    code: 'BR',
    arabicName: 'البرازيل',
    phoneCode: '+55'
  },
  {
    name: 'British Indian Ocean Territory',
    code: 'IO',
    arabicName: 'إقليم المحيط البريطاني الهندي',
    phoneCode: null
  },
  {
    name: 'Brunei Darussalam',
    code: 'BN',
    arabicName: 'بروناي دار السلام',
    phoneCode: '+673'
  },
  {
    name: 'Bulgaria',
    code: 'BG',
    arabicName: 'بلغاريا',
    phoneCode: '+359'
  },
  {
    name: 'Burkina Faso',
    code: 'BF',
    arabicName: 'بوركينا فاسو',
    phoneCode: '+226'
  },
  {
    name: 'Burundi',
    code: 'BI',
    arabicName: 'بوروندي',
    phoneCode: '+257'
  },
  {
    name: 'Cambodia',
    code: 'KH',
    arabicName: 'كمبوديا',
    phoneCode: '+855'
  },
  {
    name: 'Cameroon',
    code: 'CM',
    arabicName: 'الكاميرون',
    phoneCode: '+237'
  },
  {
    name: 'Canada',
    code: 'CA',
    arabicName: 'كندا',
    phoneCode: '+1'
  },
  {
    name: 'Cape Verde',
    code: 'CV',
    arabicName: 'كيب الأخضر',
    phoneCode: '+238'
  },
  {
    name: 'Cayman Islands',
    code: 'KY',
    arabicName: 'جزر كايمان',
    phoneCode: '+1-345'
  },
  {
    name: 'Central African Republic',
    code: 'CF',
    arabicName: 'جمهورية افريقيا الوسطى',
    phoneCode: '+236'
  },
  { name: 'Chad', code: 'TD', arabicName: 'تشاد', phoneCode: '+235' },
  { name: 'Chile', code: 'CL', arabicName: 'تشيلي', phoneCode: '+56' },
  { name: 'China', code: 'CN', arabicName: 'الصين', phoneCode: '+86' },
  { name: 'Christmas Island', code: 'CX', arabicName: 'جزيرة عيد الميلاد', phoneCode: '+61' },
  { name: 'Cocos (Keeling) Islands', code: 'CC', arabicName: 'جزر كوكوس (كيلينج)', phoneCode: '+61' },
  { name: 'Colombia', code: 'CO', arabicName: 'كولومبيا', phoneCode: '+57' },
  { name: 'Comoros', code: 'KM', arabicName: 'جزر القمر', phoneCode: '+269' },
  { name: 'Congo', code: 'CG', arabicName: 'الكونغو', phoneCode: '+242' },
  { name: 'Congo, The Democratic Republic of the', code: 'CD', arabicName: 'الكونغو ، جمهورية الديمقراطية', phoneCode: '+243' },
  { name: 'Cook Islands', code: 'CK', arabicName: 'جزر كوك', phoneCode: '+682' },
  { name: 'Costa Rica', code: 'CR', arabicName: 'كوستا ريكا', phoneCode: '+506' },
  { name: "Cote D'Ivoire", code: 'CI', arabicName: 'ساحل العاج', phoneCode: '+225' },
  { name: 'Croatia', code: 'HR', arabicName: 'كرواتيا', phoneCode: '+385' },
  { name: 'Cuba', code: 'CU', arabicName: 'كوبا', phoneCode: '+53' },
  { name: 'Cyprus', code: 'CY', arabicName: 'قبرص', phoneCode: '+357' },
  { name: 'Czech Republic', code: 'CZ', arabicName: 'الجمهورية التشيكية', phoneCode: '+420' },
  { name: 'Denmark', code: 'DK', arabicName: 'الدنمارك', phoneCode: '+45' },
  { name: 'Djibouti', code: 'DJ', arabicName: 'جيبوتي', phoneCode: '+253' },
  { name: 'Dominica', code: 'DM', arabicName: 'دومينيكا', phoneCode: '+1-767' },
  { name: 'Dominican Republic', code: 'DO', arabicName: 'جمهورية الدومينيكان', phoneCode: '+1-809' },
  { name: 'Ecuador', code: 'EC', arabicName: 'الإكوادور', phoneCode: '+593' },
  { name: 'Egypt', code: 'EG', arabicName: 'مصر', phoneCode: '+20' },
  { name: 'El Salvador', code: 'SV', arabicName: 'السلفادور', phoneCode: '+503' },
  { name: 'Equatorial Guinea', code: 'GQ', arabicName: 'غينيا الإستوائية', phoneCode: '+240' },
  { name: 'Eritrea', code: 'ER', arabicName: 'إريتريا', phoneCode: '+291' },
  { name: 'Estonia', code: 'EE', arabicName: 'إستونيا', phoneCode: '+372' },
  { name: 'Ethiopia', code: 'ET', arabicName: 'أثيوبيا', phoneCode: '+251' },
  { name: 'Falkland Islands (Malvinas)', code: 'FK', arabicName: 'جزر فوكلاند (مالفيناس)', phoneCode: '+500' },
  { name: 'Faroe Islands', code: 'FO', arabicName: 'جزر فاروس', phoneCode: '+298' },
  { name: 'Fiji', code: 'FJ', arabicName: 'فيجي', phoneCode: '+679' },
  { name: 'Finland', code: 'FI', arabicName: 'فنلندا', phoneCode: '+358' },
  { name: 'France', code: 'FR', arabicName: 'فرنسا', phoneCode: '+33' },
  { name: 'French Guiana', code: 'GF', arabicName: 'غيانا الفرنسية', phoneCode: '+594' },
  { name: 'French Polynesia', code: 'PF', arabicName: 'بولينيزيا الفرنسية', phoneCode: '+689' },
  { name: 'French Southern Territories', code: 'TF', arabicName: 'المناطق الجنوبية لفرنسا', phoneCode: null },
  { name: 'Gabon', code: 'GA', arabicName: 'الجابون', phoneCode: '+241' },
  { name: 'Gambia', code: 'GM', arabicName: 'غامبيا', phoneCode: '+220' },
  { name: 'Georgia', code: 'GE', arabicName: 'جورجيا', phoneCode: '+995' },
  { name: 'Germany', code: 'DE', arabicName: 'ألمانيا', phoneCode: '+49' },
  { name: 'Ghana', code: 'GH', arabicName: 'غانا', phoneCode: '+233' },
  { name: 'Gibraltar', code: 'GI', arabicName: 'جبل طارق', phoneCode: '+350' },
  { name: 'Greece', code: 'GR', arabicName: 'اليونان', phoneCode: '+30' },
  { name: 'Greenland', code: 'GL', arabicName: 'الأرض الخضراء', phoneCode: '+299' },
  { name: 'Grenada', code: 'GD', arabicName: 'غرينادا', phoneCode: '+1-473' },
  { name: 'Guadeloupe', code: 'GP', arabicName: 'غواديلوب', phoneCode: '+590' },
  { name: 'Guam', code: 'GU', arabicName: 'غوام', phoneCode: '+1-671' },
  { name: 'Guatemala', code: 'GT', arabicName: 'غواتيمالا', phoneCode: '+502' },
  { name: 'Guernsey', code: 'GG', arabicName: 'غيرنسي', phoneCode: null },
  { name: 'Guinea', code: 'GN', arabicName: 'غينيا', phoneCode: '+224' },
  { name: 'Guinea-Bissau', code: 'GW', arabicName: 'غينيا بيساو', phoneCode: '+245' },
  { name: 'Guyana', code: 'GY', arabicName: 'غيانا', phoneCode: '+592' },
  { name: 'Haiti', code: 'HT', arabicName: 'هايتي', phoneCode: '+509' },
  { name: 'Heard Island and Mcdonald Islands', code: 'HM', arabicName: 'قلب الجزيرة وجزر ماكدونالز', phoneCode: null },
  { name: 'Holy See (Vatican City State)', code: 'VA', arabicName: 'الكرسي الرسولي (ولاية مدينة الفاتيكان)', phoneCode: '+39' },
  { name: 'Honduras', code: 'HN', arabicName: 'هندوراس', phoneCode: '+504' },
  { name: 'Hong Kong', code: 'HK', arabicName: 'هونغ كونغ', phoneCode: '+852' },
  { name: 'Hungary', code: 'HU', arabicName: 'هنغاريا', phoneCode: '+36' },
  { name: 'Iceland', code: 'IS', arabicName: 'أيسلندا', phoneCode: '+354' },
  { name: 'India', code: 'IN', arabicName: 'الهند', phoneCode: '+91' },
  { name: 'Indonesia', code: 'ID', arabicName: 'إندونيسيا', phoneCode: '+62' },
  { name: 'Iran, Islamic Republic Of', code: 'IR', arabicName: 'إيران ، جمهورية الإسلامية', phoneCode: '+98' },
  { name: 'Iraq', code: 'IQ', arabicName: 'العراق', phoneCode: '+964' },
  { name: 'Ireland', code: 'IE', arabicName: 'أيرلندا', phoneCode: '+353' },
  { name: 'Isle of Man', code: 'IM', arabicName: 'جزيرة آيل أوف مان', phoneCode: '+44' },
  { name: 'Israel', code: 'IL', arabicName: 'إسرائيل', phoneCode: '+972' },
  { name: 'Italy', code: 'IT', arabicName: 'إيطاليا', phoneCode: '+39' },
  { name: 'Jamaica', code: 'JM', arabicName: 'جامايكا', phoneCode: '+1-876' },
  { name: 'Japan', code: 'JP', arabicName: 'اليابان', phoneCode: '+81' },
  { name: 'Jersey', code: 'JE', arabicName: 'جيرسي', phoneCode: null },
  { name: 'Jordan', code: 'JO', arabicName: 'الأردن', phoneCode: '+962' },
  { name: 'Kazakhstan', code: 'KZ', arabicName: 'كازاخستان', phoneCode: '+7' },
  { name: 'Kenya', code: 'KE', arabicName: 'كينيا', phoneCode: '+254' },
  { name: 'Kiribati', code: 'KI', arabicName: 'كيريباتي', phoneCode: '+686' },
  {
    name: "Korea, Democratic People'S Republic of",
    code: 'KP',
    arabicName: 'كوريا، الجمهورية الشعبية الديمقراطية',
    phoneCode: '+850' 
  },
  { name: 'Korea, Republic of', code: 'KR', arabicName: 'جمهورية كوريا', phoneCode: '+82' },
  { name: 'Kuwait', code: 'KW', arabicName: 'الكويت', phoneCode: '+965' },
  { name: 'Kyrgyzstan', code: 'KG', arabicName: 'قيرغيزستان', phoneCode: '+996' },
  { name: "Lao People'S Democratic Republic", code: 'LA', arabicName: 'جمهورية لاو الديمقراطية الشعبية', phoneCode: '+856' },
  { name: 'Latvia', code: 'LV', arabicName: 'لاتفيا', phoneCode: '+371' },
  { name: 'Lebanon', code: 'LB', arabicName: 'لبنان', phoneCode: '+961' },
  { name: 'Lesotho', code: 'LS', arabicName: 'ليسوتو', phoneCode: '+266' },
  { name: 'Liberia', code: 'LR', arabicName: 'ليبيريا', phoneCode: '+231' },
  { name: 'Libyan Arab Jamahiriya', code: 'LY', arabicName: 'ليبيا عرب جماهيرية', phoneCode: '+218' },
  { name: 'Liechtenstein', code: 'LI', arabicName: 'ليختنشتاين', phoneCode: '+423' },
  { name: 'Lithuania', code: 'LT', arabicName: 'ليتوانيا', phoneCode: '+370' },
  { name: 'Luxembourg', code: 'LU', arabicName: 'لوكسمبورغ', phoneCode: '+352' },
  { name: 'Macao', code: 'MO', arabicName: 'ماكاو', phoneCode: '+853' },
  {
    name: 'Macedonia, The Former Yugoslav Republic of',
    code: 'MK',
    arabicName: 'مقدونيا ، جمهورية يوغسلاف السابقة',
    phoneCode: '+389' 
  },
  { name: 'Madagascar', code: 'MG', arabicName: 'مدغشقر', phoneCode: '+261' },
  { name: 'Malawi', code: 'MW', arabicName: 'ملاوي', phoneCode: '+265' },
  { name: 'Malaysia', code: 'MY', arabicName: 'ماليزيا', phoneCode: '+60' },
  { name: 'Maldives', code: 'MV', arabicName: 'جزر المالديف', phoneCode: '+960' },
  { name: 'Mali', code: 'ML', arabicName: 'مالي', phoneCode: '+223' },
  { name: 'Malta', code: 'MT', arabicName: 'مالطا', phoneCode: '+356' },
  { name: 'Marshall Islands', code: 'MH', arabicName: 'جزر مارشال', phoneCode: '+692' },
  { name: 'Martinique', code: 'MQ', arabicName: 'مارتينيك', phoneCode: '+596' },
  { name: 'Mauritania', code: 'MR', arabicName: 'موريتانيا', phoneCode: '+222' },
  { name: 'Mauritius', code: 'MU', arabicName: 'موريشيوس', phoneCode: '+230' },
  { name: 'Mayotte', code: 'YT', arabicName: 'مايوت', phoneCode: '+262' },
  { name: 'Mexico', code: 'MX', arabicName: 'المكسيك', phoneCode: '+52' },
  { name: 'Micronesia, Federated States of', code: 'FM', arabicName: 'ميكرونيزيا ، ولايات اتحادية', phoneCode: '+691' },
  { name: 'Moldova, Republic of', code: 'MD', arabicName: 'جمهورية مولدوفا', phoneCode: '+373' },
  { name: 'Monaco', code: 'MC', arabicName: 'موناكو', phoneCode: '+377' },
  { name: 'Mongolia', code: 'MN', arabicName: 'منغوليا', phoneCode: '+976' },
  { name: 'Montserrat', code: 'MS', arabicName: 'مونتسيرات', phoneCode: '+1664' },
  { name: 'Morocco', code: 'MA', arabicName: 'المغرب', phoneCode: '+212' },
  { name: 'Mozambique', code: 'MZ', arabicName: 'موزمبيق', phoneCode: '+258' },
  { name: 'Myanmar', code: 'MM', arabicName: 'ميانمار', phoneCode: '+95' },
  { name: 'Namibia', code: 'NA', arabicName: 'ناميبيا', phoneCode: '+264' },
  { name: 'Nauru', code: 'NR', arabicName: 'ناورو', phoneCode: '+674' },
  { name: 'Nepal', code: 'NP', arabicName: 'نيبال', phoneCode: '+977' },
  { name: 'Netherlands', code: 'NL', arabicName: 'هولندا', phoneCode: '+31' },
  { name: 'New Caledonia', code: 'NC', arabicName: 'كاليدونيا الجديدة', phoneCode: '+687' },
  { name: 'New Zealand', code: 'NZ', arabicName: 'نيوزيلندا', phoneCode: '+64' },
  { name: 'Nicaragua', code: 'NI', arabicName: 'نيكاراغوا', phoneCode: '+505' },
  { name: 'Niger', code: 'NE', arabicName: 'النيجر', phoneCode: '+227' },
  { name: 'Nigeria', code: 'NG', arabicName: 'نيجيريا', phoneCode: '+234' },
  { name: 'Niue', code: 'NU', arabicName: 'نيو', phoneCode: '+683' },
  { name: 'Norfolk Island', code: 'NF', arabicName: 'جزيرة نورفولك', phoneCode: '+672' },
  { name: 'Northern Mariana Islands', code: 'MP', arabicName: 'جزر مريانا الشمالية', phoneCode: '+1-670' },
  { name: 'Norway', code: 'NO', arabicName: 'النرويج', phoneCode: '+47' },
  { name: 'Oman', code: 'OM', arabicName: 'سلطنة عمان', phoneCode: '+968' },
  { name: 'Pakistan', code: 'PK', arabicName: 'باكستان', phoneCode: '+92' },
  { name: 'Palau', code: 'PW', arabicName: 'بالاو', phoneCode: '+680' },
  { name: 'Palestinian Territory, Occupied', code: 'PS', arabicName: 'الأراضي الفلسطينية المحتلة', phoneCode: '+970' },
  { name: 'Panama', code: 'PA', arabicName: 'بنما', phoneCode: '+507' },
  { name: 'Papua New Guinea', code: 'PG', arabicName: 'بابوا غينيا الجديدة', phoneCode: '+675' },
  { name: 'Paraguay', code: 'PY', arabicName: 'باراجواي', phoneCode: '+595' },
  { name: 'Peru', code: 'PE', arabicName: 'بيرو', phoneCode: '+51' },
  { name: 'Philippines', code: 'PH', arabicName: 'فيلبيني', phoneCode: '+63' },
  { name: 'Pitcairn', code: 'PN', arabicName: 'بيتكيرن', phoneCode: '+64' },
  { name: 'Poland', code: 'PL', arabicName: 'بولندا', phoneCode: '+48' },
  { name: 'Portugal', code: 'PT', arabicName: 'البرتغال', phoneCode: '+351' },
  { name: 'Puerto Rico', code: 'PR', arabicName: 'بورتوريكو', phoneCode: '+1-787' },
  { name: 'Qatar', code: 'QA', arabicName: 'دولة قطر', phoneCode: '+974' },
  { name: 'Reunion', code: 'RE', arabicName: 'جمع شمل', phoneCode: '+262' },
  { name: 'Romania', code: 'RO', arabicName: 'رومانيا', phoneCode: '+40' },
  { name: 'Russian Federation', code: 'RU', arabicName: 'الاتحاد الروسي', phoneCode: '+7' },
  { name: 'RWANDA', code: 'RW', arabicName: 'رواندا', phoneCode: '+250' },
  { name: 'Saint Helena', code: 'SH', arabicName: 'القديس هيلينا', phoneCode: '+290' },
  { name: 'Saint Kitts and Nevis', code: 'KN', arabicName: 'سانت كيتس ونيفيس', phoneCode: '+1-869' },
  { name: 'Saint Lucia', code: 'LC', arabicName: 'القديسة لوسيا', phoneCode: '+1-758' },
  { name: 'Saint Pierre and Miquelon', code: 'PM', arabicName: 'سانت بيير وميكلون', phoneCode: '+508' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC', arabicName: 'سانت فنسنت وجزر غرينادين', phoneCode: '+1-784' },
  { name: 'Samoa', code: 'WS', arabicName: 'ساموا', phoneCode: '+685' },
  { name: 'San Marino', code: 'SM', arabicName: 'سان مارينو', phoneCode: '+378' },
  { name: 'Sao Tome and Principe', code: 'ST', arabicName: 'ساو تومي وبرينسيبي', phoneCode: '+239' },
  { name: 'Saudi Arabia', code: 'SA', arabicName: 'المملكة العربية السعودية', phoneCode: '+966' },
  { name: 'Senegal', code: 'SN', arabicName: 'السنغال', phoneCode: '+221' },
  { name: 'Seychelles', code: 'SC', arabicName: 'سيشيل', phoneCode: '+248' },
  { name: 'Sierra Leone', code: 'SL', arabicName: 'سيرا ليون', phoneCode: '+232' },
  { name: 'Singapore', code: 'SG', arabicName: 'سنغافورة', phoneCode: '+65' },
  { name: 'Slovakia', code: 'SK', arabicName: 'سلوفاكيا', phoneCode: '+421' },
  { name: 'Slovenia', code: 'SI', arabicName: 'سلوفينيا', phoneCode: '+386' },
  { name: 'Solomon Islands', code: 'SB', arabicName: 'جزر سليمان', phoneCode: '+677' },
  { name: 'Somalia', code: 'SO', arabicName: 'الصومال', phoneCode: '+252' },
  { name: 'South Africa', code: 'ZA', arabicName: 'جنوب أفريقيا', phoneCode: '+27' },
  {
    name: 'South Georgia and the South Sandwich Islands',
    code: 'GS',
    arabicName: 'جورجيا الجنوبية وجزر ساندويتش الجنوبية',
    phoneCode: '+500' 
  },
  { name: 'Spain', code: 'ES', arabicName: 'إسبانيا', phoneCode: '+34' },
  { name: 'Sri Lanka', code: 'LK', arabicName: 'سيريلانكا', phoneCode: '+94' },
  { name: 'Sudan', code: 'SD', arabicName: 'السودان', phoneCode: '+249' },
  { name: 'Suriname', code: 'SR', arabicName: 'سورينام', phoneCode: '+597' },
  { name: 'Svalbard and Jan Mayen', code: 'SJ', arabicName: 'سفالبارد وجان ماين', phoneCode: '+47' },
  { name: 'Swaziland', code: 'SZ', arabicName: 'سوازيلاند', phoneCode: '+268' },
  { name: 'Sweden', code: 'SE', arabicName: 'السويد', phoneCode: '+46' },
  { name: 'Switzerland', code: 'CH', arabicName: 'سويسرا', phoneCode: '+41' },
  { name: 'Syrian Arab Republic', code: 'SY', arabicName: 'الجمهورية العربية السورية', phoneCode: '+963' },
  { name: 'Taiwan, Province of China', code: 'TW', arabicName: 'تايوان ، مقاطعة الصين', phoneCode: '+886' },
  { name: 'Tajikistan', code: 'TJ', arabicName: 'طاجيكستان', phoneCode: '+992' },
  { name: 'Tanzania, United Republic of', code: 'TZ', arabicName: 'تنزانيا ، جمهورية موحدة', phoneCode: '+255' },
  { name: 'Thailand', code: 'TH', arabicName: 'تايلاند', phoneCode: '+66' },
  { name: 'Timor-Leste', code: 'TL', arabicName: 'قراءة تيمور', phoneCode: '+670' },
  { name: 'Togo', code: 'TG', arabicName: 'توجو', phoneCode: '+228' },
  { name: 'Tokelau', code: 'TK', arabicName: 'توكيلاو', phoneCode: '+690' },
  { name: 'Tonga', code: 'TO', arabicName: 'تونغا', phoneCode: '+676' },
  { name: 'Trinidad and Tobago', code: 'TT', arabicName: 'ترينداد وتوباغو', phoneCode: '+1-868' },
  { name: 'Tunisia', code: 'TN', arabicName: 'تونس', phoneCode: '+216' },
  { name: 'Turkey', code: 'TR', arabicName: 'ديك رومى', phoneCode: '+90' },
  { name: 'Turkmenistan', code: 'TM', arabicName: 'تركمانستان', phoneCode: '+993' },
  { name: 'Turks and Caicos Islands', code: 'TC', arabicName: 'جزر تركس وكايكوس', phoneCode: '+1-649' },
  { name: 'Tuvalu', code: 'TV', arabicName: 'توفالو', phoneCode: '+688' },
  { name: 'Uganda', code: 'UG', arabicName: 'أوغندا', phoneCode: '+256' },
  { name: 'Ukraine', code: 'UA', arabicName: 'أوكرانيا', phoneCode: '+380' },
  { name: 'United Arab Emirates', code: 'AE', arabicName: 'الإمارات العربية المتحدة', phoneCode: '+971' },
  { name: 'United Kingdom', code: 'GB', arabicName: 'المملكة المتحدة', phoneCode: '+44' },
  { name: 'United States', code: 'US', arabicName: 'الولايات المتحدة', phoneCode: '+1' },
  { name: 'United States Minor Outlying Islands', code: 'UM', arabicName: 'جزر الولايات المتحدة البعيدة الصغرى', phoneCode: '+1' },
  { name: 'Uruguay', code: 'UY', arabicName: 'أوروغواي', phoneCode: '+598' },
  { name: 'Uzbekistan', code: 'UZ', arabicName: 'أوزبكستان', phoneCode: '+998' },
  { name: 'Vanuatu', code: 'VU', arabicName: 'فانواتو', phoneCode: '+678' },
  { name: 'Venezuela', code: 'VE', arabicName: 'فنزويلا', phoneCode: '+58' },
  { name: 'Viet Nam', code: 'VN', arabicName: 'فيتنام', phoneCode: '+84' },
  { name: 'Virgin Islands, British', code: 'VG', arabicName: 'جزر العذراء البريطانية', phoneCode: '+1-284' },
  { name: 'Virgin Islands, U.S.', code: 'VI', arabicName: 'جزر فيرجن ، الولايات المتحدة', phoneCode: '+1-340' },
  { name: 'Wallis and Futuna', code: 'WF', arabicName: 'واليس وفوتونا', phoneCode: '+681' },
  { name: 'Western Sahara', code: 'EH', arabicName: 'الصحراء الغربية', phoneCode: '+212' },
  { name: 'Yemen', code: 'YE', arabicName: 'اليمن', phoneCode: '+967' },
  { name: 'Zambia', code: 'ZM', arabicName: 'زامبيا', phoneCode: '+260' },
  { name: 'Zimbabwe', code: 'ZW', arabicName: 'زيمبابوي', phoneCode: '+263' }
];
